import { Countries } from './countries';
/**
 * Short-form string representation of languages.
 * @enum {string}
 */
export var Languages;
(function (Languages) {
    Languages["SWEDISH"] = "sv";
    Languages["NORWEGIAN"] = "nb";
    Languages["DANISH"] = "da";
    Languages["FINNISH"] = "fi";
})(Languages || (Languages = {}));
export const getDefaultForCountry = country => {
    switch (country) {
        case Countries.SE:
            return Languages.SWEDISH;
        case Countries.DK:
            return Languages.DANISH;
        case Countries.NO:
            return Languages.NORWEGIAN;
        case Countries.FI:
            return Languages.FINNISH;
        default:
            return Languages.SWEDISH;
    }
};
export const getBestMatch = langCode => {
    switch (true) {
        case /^(sv)/g.test(langCode):
            return Languages.SWEDISH;
        case /^(fi)/g.test(langCode):
            return Languages.FINNISH;
        case /^(da)/g.test(langCode):
            return Languages.DANISH;
        case /^(nb|no|nn)/g.test(langCode):
            return Languages.NORWEGIAN;
        default:
            return Languages.SWEDISH;
    }
};
